import React, { Component } from 'react'
import ReactCardFlip from 'react-card-flip'
import PropTypes from 'prop-types'

import { Input } from 'loyal-react'
import { CreditCardFront, CreditCardBack } from './.'
import Select from './Select'

import CreditCardFrontImage from '@loyal_images/payment/credit-card-front.png'
import CreditCardBackImage from '@loyal_images/payment/credit-card-back.png'

const messageErrorCredidNumber =
  'O número do cartão de crédito parece inválido.'

class CreditCard extends Component {
  state = {
    isFlipped: false,
    isBackCardVisible: false,
    errors: {}
  }
  convertMoney = (value) => {
    return value.toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }
  handleFlipChange = e => {
    e.preventDefault()

    this.setState(prevState => ({ isFlipped: !prevState.isFlipped }), () => {
      this.setState({
        isBackCardVisible: this.state.isFlipped
      })
    })
  }

  validateCardNumber = ({ target: { value } }) => {
    if (value) {
      const brand = this.props.cardBrand()
      const errors = brand
        ? { ...this.state.errors, number: '' }
        : { ...this.state.errors, number: messageErrorCredidNumber }
      this.setState({ errors })
    }
  }

  fetchInstallments = (items, installmentsCash, brand) => {
    let installments = items.length > 0 ? items : installmentsCash

    if (brand) {
      let parcelas = this.props.updateInstallments(installments)
      if (installments !== parcelas && parcelas) {
        let convert = []
        for (let i = 0; i < parcelas.length; i++) {
          convert.push({
            description: this.createInstallmentDescription(parcelas[i]),
            parcel: parcelas[i].quantidadeParcelas,
            parcelValue: parcelas[i].valorParcela,
            percentInterest: parcelas[i].taxaJurosAoMes,
            valueTotal: parcelas[i].valorTotal
          })
        }
        installments = convert
      }
      this.disabled = ''
    } else {
      this.disabled = 'disabled'
      return []
    }
    return installments
  }

  createInstallmentDescription = (parcela) => {
    const installmentName = parcela.nome.toLowerCase()
    let complementaryInstallment = this.getInstallmentName(installmentName)
    return `${parcela.quantidadeParcelas} X de R$ ${this.convertMoney(parcela.valorParcela)} ${complementaryInstallment}`
  }

  getInstallmentName = (installment) => {
    const complement = (installment.indexOf('vista') > -1) ? '- À vista' : (installment.indexOf('sem juros') > -1) ? '- Sem juros' : '- Com juros'

    return complement
  }

  render () {
    const {
      payment: {
        installments: { items },
        pointsCashConfig
      },
      creditCard,
      cardBrand
    } = this.props

    const brand = cardBrand()
    const installmentsCash =
      (pointsCashConfig && pointsCashConfig.parcelCashConfigurationModel) || []

    const installments = this.fetchInstallments(items, installmentsCash, brand)

    return (
      <div className='payment-step h-auto row'>
        <div className='col-12 col-sm-6 px-0'>
          <div className='row'>
            <Input
              id='payment-card-number'
              label='Número do cartão'
              className='col-12 mt-2'
              aria-required
              required
              guide={false}
              mask={[
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              name='number'
              onChange={this.props.handleCreditCardChange}
              value={creditCard.number}
              onBlur={this.validateCardNumber}
              data-error={this.state.errors.number}
              valid={
                this.state.errors.number && creditCard.number ? false : null
              }
              aria-describedby={this.state.errors.number && creditCard.number && 'error-creditCardNumPhone'}
            />
            <Input
              id='payment-card-person-name'
              label='Nome impresso no cartão'
              className='col-12 mt-2'
              aria-required
              required
              onChange={this.props.handleCreditCardChange}
              value={creditCard.personName}
              name='personName'
            />
            <Input
              id='payment-card-person-cpf'
              label='CPF do portador do cartão'
              className='col-12 mt-2'
              aria-required
              required
              mask={[
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '.',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/
              ]}
              onChange={this.props.handleCreditCardChange}
              value={creditCard.personCPF}
              name='personCPF'
            />
            <Input
              id='payment-card-validity-date'
              label='Validade mês/ano'
              className='col-6 mt-2'
              mask={[/\d/, /\d/, '/', /\d/, /\d/]}
              aria-required
              required
              onChange={this.props.handleCreditCardChange}
              value={creditCard.validityDate}
              name={'validityDate'}
            />
            <Input
              id='payment-card-cvv'
              label='CVV'
              className='col-6 mt-2'
              mask={(typeof brand !== 'undefined' && brand.name === 'AmericanExpress' ? [/\d/, /\d/, /\d/, /\d/] : [/\d/, /\d/, /\d/])}
              aria-required
              required
              onFocus={this.handleFlipChange}
              onBlur={this.handleFlipChange}
              onChange={this.props.handleCreditCardChange}
              value={creditCard.cvv}
              name={'cvv'}
            />
            <Select
              id='payment-installment'
              label='Parcelar em'
              className='col-12 mt-2'
              displayValue='description'
              selectedValue='parcel'
              options={installments}
              value={this.props.installmentSelected()}
              onChange={this.props.handleCreditCardChange}
              name={'installment'}
              aria-required
              required
              disabled={this.disabled}
            />
          </div>
        </div>
        <div className='col-12 col-sm-6 d-none d-lg-block mt-3 mt-md-0'>
          <div className='row  align-items-center h-100'>
            <div className='col-12 txt-center pos-relative inserted'>
              <div className='image-credit-card front_credit-card'>
                <ReactCardFlip isFlipped={this.state.isFlipped}>
                  <div className='front' key='front'>
                    <img
                      src={CreditCardFrontImage}
                      alt='Cartão'
                      className='creditcard w-100'
                    />
                  </div>
                  <div className='back' key='back'>
                    <img
                      src={CreditCardBackImage}
                      alt='Cartão'
                      className='creditcard w-100'
                    />
                  </div>
                </ReactCardFlip>
              </div>
              {this.state.isBackCardVisible ? (
                <CreditCardBack {...creditCard} cvv={typeof brand !== 'undefined' && brand.name === 'AmericanExpress' ? '****' : '***'} />
              ) : (
                <CreditCardFront {...creditCard} cardBrand={cardBrand} />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

CreditCard.propTypes = {
  payment: PropTypes.object.isRequired,
  creditCard: PropTypes.object.isRequired,
  handleCreditCardChange: PropTypes.func.isRequired,
  installmentSelected: PropTypes.func.isRequired,
  cardBrand: PropTypes.func.isRequired,
  updateInstallments: PropTypes.func,
  disabled: PropTypes.string
}

export default CreditCard



// WEBPACK FOOTER //
// ./src/features/Checkout/Payment/Body/PointsCash/CreditCard.js